// Prosty lokalny stan „ręcznie nieprzeczytanych” powiadomień.
// Używany do cofania oznaczenia przeczytania bez wsparcia backendu.

const KEY = 'notif:manual-unread:v1';

function readSet(): Set<number> {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw) as Array<number>;
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.map((x) => Number(x)).filter((x) => Number.isFinite(x)));
  } catch {
    return new Set();
  }
}

function writeSet(s: Set<number>) {
  try {
    localStorage.setItem(KEY, JSON.stringify(Array.from(s)));
  } catch {}
}

export function getManualUnreadIds(): number[] {
  return Array.from(readSet());
}

export function manualUnreadCount(): number {
  return readSet().size;
}

export function isManualUnread(id: number): boolean {
  return readSet().has(id);
}

export function setManualUnread(id: number, value: boolean) {
  const s = readSet();
  if (value) s.add(id);
  else s.delete(id);
  writeSet(s);
  try { window.dispatchEvent(new CustomEvent('notifications:manualUnreadChanged', { detail: { count: s.size } })); } catch {}
}

export function clearManualUnread() {
  writeSet(new Set());
  try { window.dispatchEvent(new CustomEvent('notifications:manualUnreadChanged', { detail: { count: 0 } })); } catch {}
}


